import React from 'react';
import { Card } from 'reactstrap';
import adform from '../../../../../assets/images/publish/adform.png';

function PublishAdform({item, onSelect}) {
  return (
    <Card className='p-3 d-flex flex-column align-items-center h-100'>
      <img src={adform} className='w-75 mb-3' style={{maxHeight: '30px', objectFit: 'contain'}} draggable='false' />
      <h4 className='m-0 mb-3 text-body text-center text-truncate'>Adform</h4>
      <p className='text-muted text-center'>Publish your banners directly to Adform. Choose your Adform settings in the next steps.</p>
      <button className='w-100 btn btn-info mb-0 mt-auto' onClick={onSelect}>Choose</button>
    </Card>
  )
}

export default PublishAdform
